<template>
  <div class="ss__user__menu__wrapper">
    <div v-if="user" class="ss__user__menu">
        <div class="ss__user__menu__main">
          <a :href="`/u/${user.slug}`" class="ss__user__menu__profile">
            <SsPortrait
              class="comp__SsPortrait"
              :data="user"
              :size="32"
              :proportion="1"
            />
            <span class="ss__user__menu__profile__nickname">{{ user.nickname }}</span>
            <i class="ssCommunityIcon__arrowMore"/>
          </a>
        </div>
      <div class="ss__user__menu__default__wrapper">
        <a
        :href="item.link"
          v-for="item in defaultMenu"
          :key="item.name"
          class="ss__user__menu__item">
          <i :class="['ss__user__menu__item__icon', item.iconClass]"/>
          <span>{{ item.name }}</span>
          <i v-if="reminders && reminders[item.type]" class="ss__user__menu__item_reminders"/>
        </a>
      </div>
      <div class="ss__user__nemu__works__wrapper">
        <a
          :href="item.link"
          v-for="item in worksMenu"
          :key="item.name"
          class="ss__user__menu__item">
          <i :class="['ss__user__menu__item__icon', item.iconClass]"/>
          <span>{{ item.name }}</span>
          <i v-if="reminders && reminders[item.type]" class="ss__user__menu__item_reminders"/>
        </a>
      </div>
      <div class="ss__user__menu__setting__wrapper">
        <div
          :class="[
            'ss__user__menu__setting',
            { 'ss__user__menu__setting--hidden': appearanceSettingShow }
          ]">
          <div
            class="ss__user__menu__setting__appearance"
            tabindex="-1"
            @focusin="appearanceSettingShow = true"
            @focusout="appearanceSettingShow = false">
            <SsButton2
              class="ss__user__menu__setting__button"
              type="text">
              <i class="ssCommunityIcon__appearance"/>
              <span>外观</span>
            </SsButton2>
            <Transition name="appearanceSettingShow">
              <SsAppearanceSetting
                v-show="appearanceSettingShow"
                class="comp__SsAppearanceSetting"
                :options="appearanceOptions"
                :value="appearanceValue"
                @change="onAppearanceChange"
              />
            </Transition>
          </div>
          <a class="ss__user__menu__setting__button" type="text" href="/setting/profile">
            <i class="ssCommunityIcon__setting"/>
            <span>账号设置</span>
          </a>
          <SsButton2 class="ss__user__menu__setting__button" type="text" @click="$emit('logout')">
            <i class="ssCommunityIcon__signOut"/>
            <span>登出</span>
          </SsButton2>
        </div>
      </div>

      <div
        v-show="appearanceSettingShow"
        class="ss__user__menu__mask"
        @click="appearanceSettingShow = false">
      </div>
    </div>
  </div>
</template>

<script>
import SsAppearanceSetting from '../SsAppearanceSetting/index.vue'
import SsButton2 from '../../../SsButton2'
import SsPortrait from '../../../SsPortrait'

export default {
  name: 'SsCustomHeaderUserMenu',

  components: {
    SsAppearanceSetting,
    SsButton2,
    SsPortrait
  },

  props: {
    user: {
      type: Object
    },
    reminders: {
      type: Object,
      default: () => (
        {
          series: true,
          series_comment: true
        }
      )
    }
  },

  data () {
    return {
      appearanceOptions: [
        { label: '跟随系统', value: 0, icon: 'ssCommunityIcon__appearance' },
        { label: '亮色', value: 1, icon: 'ssCommunityIcon__light' },
        { label: '暗色', value: 2, icon: 'ssCommunityIcon__dark' }
      ],
      appearanceSettingShow: false,
      appearanceValue: 0
    }
  },

  computed: {
    isSeriesAuthor () {
      return this.user && this.user.is_series_author
    },
    defaultMenu () {
      return [
        {
          name: '我的收藏',
          iconClass: 'ssCommunityIcon__favorited--line',
          link: `/u/${this.user.slug}/favorites`,
          type: 'favorite'
        },
        {
          name: '已购栏目',
          iconClass: 'ssCommunityIcon__journal',
          link: '/series/my',
          type: 'series'
        },
        {
          name: '订单与优惠券',
          iconClass: 'ssCommunityIcon__order',
          link: '/my/order',
          type: 'order'
        }
      ]
    },
    worksMenu () {
      const menu = [
        {
          name: '我的收益',
          iconClass: 'ssCommunityIcon__wallet',
          link: '/my/wallet',
          type: 'wallet'
        },
        {
          name: '我的文章',
          iconClass: 'ssCommunityIcon__post',
          link: '/my/post/draft',
          type: 'post'
        }
      ]
      if (this.isSeriesAuthor) {
        menu.push(
          {
            name: '栏目评论管理',
            iconClass: 'ssCommunityIcon__chatBubble',
            link: '/my/series/comment',
            type: 'series_comment'
          }
        )
      }
      return menu
    }
  },

  methods: {
    onAppearanceChange (v) {
      this.appearanceValue = v
      window.localStorage.setItem('darkMode', v)
      if (this.$bus) {
        this.$bus.$emit('darkModeChange')
      } else {
        dispatchEvent(new CustomEvent('ssCustomHeaderDarkModeChange'))
      }
    }
  },

  mounted () {
    this.appearanceValue = window.localStorage.getItem('darkMode') ? parseInt(window.localStorage.getItem('darkMode')) : 0
  }
}
</script>

<style lang="stylus" scoped>
.ss__user__menu {
  position: relative;
  z-index: 2;
  width: 298px;
  margin: auto;
  border-radius: 16px;
  border: 1px solid var(--B2-t-overlay);
  background: var(--B0-t-overlay);
  box-shadow: var(--shadow-level-3);
  overflow: hidden;

  color: var(--B8-t);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;

  a {
    color: inherit;
    &:hover {
      color: inherit;
    }
  }
}

.ss__user__menu__profile {
  padding: 20px;
  display: flex;
  column-gap: 8px;
  align-items: center;
  transition: background .2s;
  .comp__SsPortrait {
    --size: 32px;
    --proportion: 1;
  }
  .ss__user__menu__profile__nickname {}
  .ssCommunityIcon__arrowMore {
    font-size: 20px;
    margin-left: auto;
  }
  &:hover, &:focus {
    background: var(--B1-t-overlay);
  }
}

.ss__user__menu__default__wrapper,
.ss__user__nemu__works__wrapper,
.ss__user__menu__setting__wrapper {
  padding: 4px 0;
  border-top: 1px solid var(--B2-t-overlay);
}

.ss__user__menu__item {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  transition: background .2s;
  .ss__user__menu__item__icon {
    font-size: 20px;
  }
  .ss__user__menu__item_reminders {
    width: 8px;
    height: 8px;
    background: var(--red-t);
    border-radius: 8px;
    margin-left: auto;
  }
  &:hover, &:focus {
    background: var(--B1-t-overlay);
  }
}

.ss__user__menu__setting__wrapper {
  padding: 12px;
}
.ss__user__menu__setting {
  display: flex;
  justify-content: space-between;
}

.ss__user__menu__setting__button {
  opacity: 1;
  transition: opacity var(--a-dur-short) var(--a-func-short);
}
.ss__user__menu__setting--hidden {
  .ss__user__menu__setting__button {
    opacity: 0;
  }
}

.ss__user__menu__setting__button,
a.ss__user__menu__setting__button {
  width 86px;
  height: 70px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 4px;
  color: var(--B6-t-overlay);
  border-radius: 12px;
  transition: all 0.2s;
  [class^="ssCommunityIcon__"], [class*=" ssCommunityIcon__"] {
    font-size: 24px;
  }
  &:hover {
    background: var(--B1-t-overlay);
    color: var(--B8-t-overlay);
  }
}

.ss__user__menu__setting__appearance {
  position: relative;
  z-index: 2;
  .comp__SsAppearanceSetting {
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 12px;
    transform-origin: left center;
  }
}
.appearanceSettingShow-enter-active,
.appearanceSettingShow-leave-active {
  opacity: 1;
  width: 264px;
  overflow: hidden;
  transition: all var(--a-dur-short) cubic-bezier(0, 0, 0.2, 1);
}

.appearanceSettingShow-enter,
.appearanceSettingShow-leave-to {
  opacity: 0;
  width: 0px;
}

.ss__user__menu__mask {
  position: absolute;
  opacity: 0;
  background: #000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
}
</style>
